<template>
  <div class="bg-white rounded bg-opacity-75 shadow-xl p-0 sm:p-1 md:p-2 lg:p-3">
      <slot>

      </slot>
  </div>
</template>

<script>
export default {
    name: "card"
}
</script>
